import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ValuePlaceholder } from '@openx/components-core/lib/Value/ValuePlaceholder/ValuePlaceholder';
import { convertToPercent } from '@openx/utils/lib/convertToPercent';
import { useTranslation } from 'react-i18next';
import type { GetAudiencesListQuery } from '../../../../../graphql/query/audiences/GetAudiencesList.generated';
import { MatchingOperator } from '../../../AudienceForm/constants';

type PriceCellProps = {
  pricing: GetAudiencesListQuery['audience'][number]['pricing'];
};

export const PriceCell = ({ pricing }: PriceCellProps) => {
  const { t } = useTranslation();

  if (!pricing?.totals) {
    return <ValuePlaceholder />;
  }

  const formattedCpm = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
    Math.round(pricing.totals.price_cpm * 100) / 100
  );

  return (
    <Stack>
      {pricing.operator === MatchingOperator.UNION && (
        <Box>
          <Typography color="textSecondary" component="span" variant="body2">
            {t('Percent of Media')}:
          </Typography>{' '}
          <Typography component="span" sx={{ wordBreak: 'keep-all' }} variant="body2">
            {convertToPercent(pricing.totals.price_pom)}%
          </Typography>
        </Box>
      )}
      <Box>
        <Typography color="textSecondary" component="span" variant="body2">
          {t('Fixed CPM')}:
        </Typography>{' '}
        <Typography component="span" sx={{ wordBreak: 'keep-all' }} variant="body2">
          ${formattedCpm}
        </Typography>
      </Box>
    </Stack>
  );
};
